import { Box } from '@mui/material';

import PremiumFeatureMessage from '@/components/UpgradeToPremium/PremiumFeatureMessage';
import { Permission } from '@/entities/permissions';
import usePermission from '@/shared/hooks/usePermission';

const BlurBackdrop = () => {
  const { hasPermission } = usePermission();

  if (hasPermission(Permission.ViewIndexInformationChart)) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backdropFilter: 'blur(4px)',
          zIndex: 1400
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '50%',
          textAlign: 'center',
          transform: 'translateX(-50%)',
          zIndex: 1401,
          width: '100%'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <PremiumFeatureMessage sx={{ fontWeight: 600, fontSize: '24px' }} />
        </Box>
      </Box>
    </>
  );
};

export default BlurBackdrop;
